module.exports = class ComponentModel extends Backbone.Model
    defaults:
        componentType: 'default'
